var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F7F8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.243 20.243C20.5034 19.9827 20.5034 19.5606 20.243 19.3002L16.9437 16.0009L20.244 12.7006C20.5043 12.4402 20.5043 12.0181 20.244 11.7578C19.9836 11.4974 19.5615 11.4974 19.3011 11.7578L16.0009 15.058L12.7006 11.7578C12.4402 11.4974 12.0181 11.4974 11.7578 11.7578C11.4974 12.0181 11.4974 12.4402 11.7578 12.7006L15.058 16.0009L11.7587 19.3002C11.4983 19.5606 11.4983 19.9827 11.7587 20.243C12.019 20.5034 12.4411 20.5034 12.7015 20.243L16.0009 16.9437L19.3002 20.243C19.5606 20.5034 19.9827 20.5034 20.243 20.243Z",
    fill: "#191D23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.70de1cf7ce0b1a1384bed8a4bc2d9f35.svg";
export { ForwardRef as ReactComponent };